import React from 'react';
export default ({ dispatch }) => next => action => {
  const { cardAction: { type, value } } = action;
  if (type == 'openUrl' && value.includes(':Webview')) {
    var url = value;
    var indexWebView = url.indexOf(':Webview');
    var jsonData = JSON.parse(url.substring(indexWebView + 8));
    var webViewUrl = url.substring(0, indexWebView);
    dispatch({
      type: 'WEB_CHAT/SEND_EVENT',
      payload: {
        name: 'webchat/openWebView',
        value: { url: `${webViewUrl}`, title: jsonData.title, mode: jsonData.mode, largeWindowHideHeader: false }
      }
    });
  }
  else {
    return next(action);
  }
}